import { render, staticRenderFns } from "./FormControlContentType.vue?vue&type=template&id=2b3b15dc"
import script from "./FormControlContentType.vue?vue&type=script&lang=js"
export * from "./FormControlContentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b3b15dc')) {
      api.createRecord('2b3b15dc', component.options)
    } else {
      api.reload('2b3b15dc', component.options)
    }
    module.hot.accept("./FormControlContentType.vue?vue&type=template&id=2b3b15dc", function () {
      api.rerender('2b3b15dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Form/Control/FormControlContentType.vue"
export default component.exports